import { render } from "./TheHeader.vue?vue&type=template&id=0784b734&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=0784b734&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0784b734"]])

export default __exports__